<template>
	<div class="ModuleLayout">
		<el-scrollbar ref="ScrollbarRef" @scroll="HandleScroll">
			<el-container>
				<el-header>
					<ComponentsTop ref="ComponentsTop" @onSearch="Search" @onScrollTop="ImmediatelyScrollTop"/>
				</el-header>
				<el-main>
					<router-view v-slot="{ Component }">
						<transition>
							<component :is="Component" @onScrollTop="ImmediatelyScrollTop" ref="ComponentsMain"/>
						</transition>
					</router-view>
				</el-main>
				<el-footer>
					<ComponentsBottom/>
				</el-footer>
			</el-container>
		</el-scrollbar>
	</div>
	<div class="ModuleArrow" v-if="IsArrow" @click="ScrollTop"></div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
